import {DocumentUIField} from '@/engine';
import {FieldProps} from '../../meta-field';

export const DividerField = ({field}: FieldProps<DocumentUIField>) => {
  return <hr data-testid={field.id} className="my-3 border-t border-grey-400" />;
};
